<template>
  <div>
    <c-list
      :data="list.items"
      :columns="cList.columns"
      :total="list.total"
      :page-current="listPageCurrent"
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
      <c-list-header>
        <c-list-operations>
          <Button type="primary" @click="$refs.form.show()">
            新增
          </Button>
          <c-bulk-delete
            :selected-items="listSelectedItems"
            @ok="confirmDelete"
          >
          </c-bulk-delete>
          <Button @click="$helpers.goBack()">
            返回
          </Button>
        </c-list-operations>
      </c-list-header>
    </c-list>
    <c-list-form ref="form" @get-list="getList"></c-list-form>
    <c-class-hours-form
      ref="classHoursForm"
      @get-list="getList"
    ></c-class-hours-form>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import ListForm from "./form";
import ClassHoursForm from "./class-hours-form";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";

const module = "classStudents";
const initWhere = {};

@Component({
  mixins: [RouteParamsMixin, ListMixin],
  components: {
    "c-list-form": ListForm,
    "c-class-hours-form": ClassHoursForm
  },
  computed: mapState({
    list: state => state[module].list
  })
})
export default class extends Vue {
  data() {
    const { ListColumnWidth } = this.$consts;

    return {
      cList: {
        columns: [
          {
            type: "selection",
            width: 60
          },
          {
            title: "姓名",
            minWidth: ListColumnWidth.Title,
            render: (h, { row }) => h("span", row.student.name)
          },
          {
            title: "总金额",
            key: "classMoney",
            width: 100
          },
          {
            title: "每课程费用",
            key: "classHours",
            width: 100,
            render:(h, { row }) => h('div', row['classHours'] > 0 ? row['classMoney'] / row['classHours'] : 0)
          },
          {
            title: "剩余金额",
            key: "classHours",
            width: 100,
            render:(h, { row }) => h('div', (row['classHours'] - row['usedClassHours']) * (row['classHours'] > 0 ? row['classMoney'] / row['classHours'] : 0))
          },
          {
            title: "已用金额",
            key: "classHours",
            width: 100,
            render:(h, { row }) => h('div', row['usedClassHours'] * (row['classHours'] > 0 ? row['classMoney'] / row['classHours'] : 0))
          },
          {
            title: "总课时",
            key: "classHours",
            width: 100
          },
          {
            title: "已用课时",
            key: "usedClassHours",
            width: 100
          },
          {
            title: "操作",
            key: "action",
            width: 220,
            render: (h, { row }) =>
              h("div", [
                h(
                  "Button",
                  {
                    on: {
                      click: () => {
                        this.$refs.classHoursForm.show(row);
                      }
                    }
                  },
                  "设置课时/金额"
                ),
                h("c-confirm-button", {
                  props: {
                    buttonText: "删除",
                    confirmText: "确认删除？"
                  },
                  on: {
                    ok: () => {
                      this.confirmDelete(row.id);
                    }
                  }
                })
              ])
          }
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        }
      }
    };
  }

  async beforeRouteUpdate(to, from, next) {
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    this.initListSearchWhere(initWhere);
    this.getList();
  }

  getList() {
    return this.$store.dispatch(`${module}/getList`, {
      query: {
        offset: (this.listPageCurrent - 1) * this.$consts.PageSize,
        limit: this.$consts.PageSize,
        include: [{ model: "Student", as: "student" }],
        where: {
          ...this.listSearchWhere,
          classId: this.$route.params.classId
        },
        order: [["order", "DESC"]]
      }
    });
  }

  async confirmDelete(ids) {
    await this.$store.dispatch(`${module}/delete`, { id: ids });
    this.$Message.success("删除成功");

    const { items } = await this.getList();
    !items.length && this.goListPrevPage();
  }
}
</script>
